import {CopilotIcon, PaperAirplaneIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'
import {useCallback, useRef} from 'react'

import {sendSuggestionsShown, useAskCopilotPrompts} from './use-ask-copilot-prompts'

const ASK_COPILOT_LOCATION = 'readme-header'

/**
 * Icon-only "Ask Copilot" entry point rendered in the README header tab bar. Clicking the trigger
 * opens a menu of icebreaker prompts; selecting one opens Copilot Chat seeded with that prompt.
 */
export function AskCopilotReadmeMenu() {
  const suggestionsShownRef = useRef(false)
  const {prompts, onPromptClick} = useAskCopilotPrompts({location: ASK_COPILOT_LOCATION, readme: true})

  // The prompts only become visible when the menu overlay opens, so fire the "shown" event on the
  // first open rather than on mount to avoid attributing impressions to users who never open it.
  const onOpenChange = useCallback((open: boolean) => {
    if (!open || suggestionsShownRef.current) return
    suggestionsShownRef.current = true

    sendSuggestionsShown(ASK_COPILOT_LOCATION)
  }, [])

  return (
    <ActionMenu onOpenChange={onOpenChange}>
      <ActionMenu.Anchor>
        <IconButton
          icon={CopilotIcon}
          aria-label="Ask Copilot about this repository"
          variant="invisible"
          size="small"
        />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay width="medium">
        <ActionList>
          {prompts.map(prompt => (
            <ActionList.Item key={prompt.label} onSelect={() => onPromptClick(prompt)}>
              <ActionList.LeadingVisual>
                <PaperAirplaneIcon />
              </ActionList.LeadingVisual>
              {prompt.label}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
